export default __webpack_public_path__ + "app/assets/Logo_placeholder-77b1612d.png";